import { TrashIcon } from '@heroicons/react/24/outline'
import { useTranslation } from '../../core/hooks/useTranslation'

interface DeleteButtonProps<T = any> {
    onClick: (itemOrId: T) => void
    itemOrId: T
    className?: string
    showLabel?: boolean
}

export default function DeleteButton<T = any>({
    onClick,
    itemOrId,
    className = '',
    showLabel = true
}: DeleteButtonProps<T>) {
    const { t } = useTranslation()

    return (
        <button
            onClick={() => onClick(itemOrId)}
            className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-red-600 bg-white border border-red-200 rounded-lg hover:bg-red-50 hover:border-red-300 transition-colors ${className}`}
            title={t('delete')}
        >
            <TrashIcon className="w-3.5 h-3.5" />
            {showLabel && <span>{t('delete')}</span>}
        </button>
    )
}

